<template>
	<div class="radio-button-group">
		<label v-if="hasLabel" class="form-label"
		>{{ label }}</label>
		<!--	We need a custom input handler because it's not a standard input I think... 	-->
		<base-radio-button v-for="option in options" :option="option" :key="option.value" :input-class="inputClass" :name="name" :input-id="inputId" :label="option.label" @input="(value) => $emit('input', value)" />
	</div>
</template>

<script>


import BaseRadioButton from "./BaseRadioButton.vue";

export default {
	name: 'BaseRadioButtonGroup',
	components: {BaseRadioButton},
	props: {
		options: {
			required: true,
			type: Array
		},
		name: {
			type: String,
			required: true,
		},
		inputClass: {
			type: String,
			required: false
		},
		inputId: {
			type: String,
			required: true
		},
		label: {
			type: String,
			required: false
		}
	},
	computed: {
		hasLabel() {
			return this.label && this.label.length > 0;
		}
	}
}
</script>